import * as FaunaDB from 'faunadb';
import { ExprArg } from 'faunadb/src/types/query';

import { AOService } from '../services/ao.service';
import { AOFaunaDbService } from '../services/ao-fauna-db.service';

export class AOFaunaDBPaginationHelper {

  private _filters_show = true;

  private _filters_model: any = {};

  private _filters: any = {};

  private _query: (q, params: any) => any;

  private _columns: string[];

  private _search: any;

  private _size = 20;

  private _response: any;

  private _last_after: any;

  private _refresh: any;

  constructor(
    private _ao: AOService,
    private _db: AOFaunaDbService,
  ) {
  }

  //--------------------------------------------------------------------------------------------------------------------

  filters(filters?: any) {
    if (filters) {
      this._filters_model = {...filters};
      this._filters = {...filters};
      return this;
    }

    return this._filters;
  }

  openFilters() {
    this._filters_show = true;
  }

  closeFilters() {
    this._filters_show = false;
  }

  toggleFilters() {
    this._filters_show = !this._filters_show;
  }

  showFilters() {
    return this._filters_show;
  }

  hideFilters() {
    return !this._filters_show;
  }

  hasFilters() {
    return Object
      .keys(this._filters_model)
      .filter(key => this._filters_model[key] !== this._filters[key])
      .length > 0;
  }

  resetFilters() {
    this._filters = {...this._filters_model};
    this.openFilters();
  }

  //--------------------------------------------------------------------------------------------------------------------

  select(columns: string[]) {
    return (this._columns = [...columns]) && this;
  }

  query(query: (q, params: any) => any) {
    return (this._query = query) && this;
  }

  search() {
    this._last_after = undefined;
    this._refresh = undefined;
    this._search = this._query(FaunaDB.query, {...this.filters()});
    return this.first();
  }

  first() {
    return this.paginate(this._search, {
      size: this._size,
      before: undefined,
      after: undefined,
    });
  }

  previous() {
    return this.paginate(this._search, {
      size: this._size,
      after: undefined,
      before: this._response.before,
    });
  }

  next() {
    return this.paginate(this._search, {
      size: this._size,
      after: this._response.after,
      before: undefined,
    });
  }

  last() {
    return this.paginate(this._search, {
      size: this._size,
      after: this._last_after,
      before: undefined,
    });
  }

  refresh(event?) {
    let promise;

    if (this.empty()) {
      if (this._response) {
        promise = this.previous();
      } else {
        promise = this.search();
      }
    } else {
      promise = this.paginate(this._search, this._refresh);
    }

    return promise.then(response => {
      event ? event.target.complete() : null;
      return response;
    });
  }

  private paginate(set: ExprArg, opts?: object) {

    this._refresh = {...opts};

    let paginate = FaunaDB.query.Paginate(set, opts);

    if (this._columns) {
      paginate = FaunaDB.query.Map(paginate, item => this._columns.reduce(
        (select, column, index) => (select[column] = FaunaDB.query.Select(index + 1, item)) && select, {}
      ));
    }

    return this._db.query(() => paginate)
      .then((response: any) => {

        if (this._response && this._response.after && !response.after) {
          this._last_after = this._response.after;
        }

        this._response = response;
        this.closeFilters();

      }).catch(error => {

        this._ao.danger('Oops! Falha ao realizar a buscar :(', {error});

      });
  }

  hasPrevious() {
    return !!(this._response && this._response.before);
  }

  hasNext() {
    return !!(this._response && this._response.after);
  }

  hasLast() {
    return !!this._last_after;
  }

  isFirst() {
    return !this.hasPrevious();
  }

  isLast() {
    return !this.hasNext();
  }

  //--------------------------------------------------------------------------------------------------------------------

  response(): any {
    return this._response ? this._response : null;
  }

  items(): any[] {
    return this._response && this._response.data ? this._response.data : [];
  }

  empty(): boolean {
    return this.items().length === 0;
  }

}
